<template>
  <div class="toast-container">
    <Toast
      v-for="toast in toasts"
      :id="toast.id"
      :key="toast.id"
      :type="toast.type"
      :title="toast.title"
      :message="toast.message"
      :duration="toast.duration"
      :undo-id="toast.undoId"
      @close="removeToast"
      @undo="handleUndo"
    />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useToastStore } from '../stores/toast';
import Toast from './Toast.vue';

const toastStore = useToastStore();
const { toasts } = storeToRefs(toastStore);
const { removeToast, handleUndo } = toastStore;
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  pointer-events: none;
  z-index: 9999;
}

.toast-container > * {
  pointer-events: auto;
}
</style>
